// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Upload = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Upload = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Upload = _exports.Upload = function Upload(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10.6628 2.15067C10.4886 1.97294 10.2501 1.875 10.0002 1.875C9.75031 1.875 9.51177 1.97294 9.3376 2.15067L4.49111 7.08371C4.14655 7.43555 4.16548 7.98326 4.52897 8.31334C4.89246 8.64341 5.46798 8.62528 5.81253 8.27706L9.09149 4.94001V7.96875V12.6116C9.09149 13.094 9.49662 13.4821 10.0002 13.4821C10.5038 13.4821 10.9089 13.094 10.9089 12.6116V7.96875V4.94001L14.1841 8.27344C14.5286 8.62528 15.1042 8.63979 15.4677 8.30971C15.8311 7.97963 15.8501 7.42829 15.5055 7.08008L10.659 2.14704L10.6628 2.15067ZM3.63919 16.3839C3.13561 16.3839 2.73047 16.772 2.73047 17.2545C2.73047 17.7369 3.13561 18.125 3.63919 18.125H16.3612C16.8648 18.125 17.2699 17.7369 17.2699 17.2545C17.2699 16.772 16.8648 16.3839 16.3612 16.3839H3.63919Z",
      fill: "#212B36"
    }));
  };
});
